import { Injectable } from '@angular/core';
import io, { Socket } from 'socket.io-client';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

// socket.io-stream
declare const ss: any;

@Injectable({
  providedIn: 'root',
})
export class SttSocketService {
  private socket: Socket;
  private currentRoom = '';
  private connected$ = new BehaviorSubject<boolean>(false);

  constructor() {}

  public emitEvent(eventName: string, data: any) {
    return this.socket.emit(eventName, data);
  }

  public sendBinaryStream(
    blob: any,
    data?: { uid: string; name: string; size: number; language: string }
  ) {
    const me = this;
    const stream = ss.createStream();
    ss(me.socket).emit('stream-speech', stream, {
      ...data,
    });
    // pipe the audio blob to the read stream
    ss.createBlobReadStream(blob).pipe(stream);
  }

  public onEvent(eventName: string): Observable<any> {
    return new Observable((subscriber) => {
      this.socket.on(eventName, (val: any) => {
        subscriber.next(val);
      });
    });
  }

  public connectionStatus() {
    return this.connected$.asObservable();
  }

  public joinRoom(roomId: string) {
    this.socket.emit('joinRoom', roomId);
    this.currentRoom = roomId;
  }

  public leaveRoom(roomId: string) {
    this.socket.emit('leaveRoom', roomId);
    this.currentRoom = '';
  }

  public initSocket() {
    const socketURL = new URL(`${environment.urlMessaging}`);
    this.socket = io(socketURL.origin + '/speechtotext', {
      upgrade: true,
      transports: ['websocket'],
      autoConnect: true,
    });

    this.socket.binaryType = 'arraybuffer';

    this.socket.on('connect', () => {
      this.connected$.next(true);

      if (this.currentRoom) {
        this.joinRoom(this.currentRoom);
      }
    });

    this.socket.on('error', (data) => {
      console.error('err', data);
      this.connected$.next(false);
    });
  }
}
